import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private readonly config = inject(PrimeNG);

  ngOnInit(): void {
    this.config.setTranslation({
      startsWith: 'Inizia con',
      contains: 'Contiene',
      notContains: 'Non contiene',
      endsWith: 'Finisce con',
      equals: 'Uguale a',
      notEquals: 'Diverso da',
      noFilter: 'Nessun filtro',
      lt: 'Minore di',
      lte: 'Minore o uguale a',
      gt: 'Maggiore di',
      gte: 'Maggiore o uguale a',
      is: 'È',
      isNot: 'Non è',
      before: 'Prima di',
      after: 'Dopo',
      dateIs: 'È',
      dateIsNot: 'Non è',
      dateBefore: 'Prima di',
      dateAfter: 'Dopo',
      clear: 'Cancella',
      apply: 'Applica',
      matchAll: 'Tutto',
      matchAny: 'Qualcuno',
      addRule: 'Aggiungi regola',
      removeRule: 'Rimuovi regola',
      accept: 'Accetta',
      reject: 'Rifiuta',
      choose: 'Scegli',
      upload: 'Carica',
      cancel: 'Annulla',
      dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
      dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
      dayNamesMin: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
      monthNames: [
        'Gennaio',
        'Febbraio',
        'Marzo',
        'Aprile',
        'Maggio',
        'Giugno',
        'Luglio',
        'Agosto',
        'Settembre',
        'Ottobre',
        'Novembre',
        'Dicembre',
      ],
      monthNamesShort: [
        'Gen',
        'Feb',
        'Mar',
        'Apr',
        'Mag',
        'Giu',
        'Lug',
        'Ago',
        'Set',
        'Ott',
        'Nov',
        'Dic',
      ],
      dateFormat: 'dd/MM/yyyy',
      firstDayOfWeek: 1,
      today: 'Oggi',
      weekHeader: 'Settimana',
      weak: 'Debole',
      medium: 'Media',
      strong: 'Forte',
      passwordPrompt: 'Inserisci una password',
      emptyMessage: 'Nessun dato trovato',
      emptyFilterMessage: 'Nessun dato trovato',
    });
  }
}
